export function Services() {
  const services = [
    {
      image: 'https://public.readdy.ai/ai/img_res/c269a6b492e001878f6c357670f2b758.jpg',
      tag: 'Adolescentes e Adultos',
      title: 'Terapia Individual',
      description: 'Processo personalizado de autoconhecimento para lidar com ansiedade, depressão, relacionamentos e desafios do dia a dia.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=two%20hands%20holding%20together%20symbolizing%20connection%20and%20support%20warm%20intimate%20atmosphere%20soft%20lighting%20representing%20couple%20therapy%20relationship%20healing%20emotional%20bond%20trust%20partnership%20simple%20clean%20background%20therapeutic%20concept&width=800&height=600&seq=service002&orientation=landscape',
      tag: 'Relacionamentos',
      title: 'Terapia de Casal',
      description: 'Fortalecimento de vínculos, melhoria da comunicação e resolução de conflitos para casais que buscam harmonia.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=therapy%20materials%20books%20journals%20notebooks%20on%20organized%20desk%20professional%20therapeutic%20resources%20educational%20tools%20clean%20workspace%20natural%20lighting%20supportive%20materials%20psychology%20books%20simple%20composition%20calming%20environment&width=800&height=600&seq=service003&orientation=landscape',
      tag: 'Suporte Extra',
      title: 'Atendimento Personalizado',
      description: 'Cada sessão é adaptada às suas necessidades específicas, com abordagem individualizada e focada em seus objetivos.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=smartphone%20with%20messaging%20app%20on%20wooden%20table%20representing%20online%20therapy%20support%20digital%20communication%20modern%20technology%20therapeutic%20connection%20remote%20counseling%20accessible%20mental%20health%20clean%20minimal%20background&width=800&height=600&seq=service004&orientation=landscape',
      tag: 'Continuidade',
      title: 'Apoio Fora das Sessões',
      description: 'Acompanhamento contínuo entre as sessões para garantir seu progresso e oferecer suporte quando você precisar.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=therapy%20workbook%20exercises%20and%20worksheets%20on%20desk%20with%20pen%20self%20help%20materials%20psychological%20tools%20educational%20resources%20structured%20support%20therapeutic%20homework%20organized%20layout%20professional%20setting%20clean%20background&width=800&height=600&seq=service005&orientation=landscape',
      tag: 'Recursos',
      title: 'Material de Apoio',
      description: 'Recursos terapêuticos, exercícios práticos e materiais complementares para potencializar sua evolução.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=calendar%20planner%20with%20scheduled%20appointments%20organized%20time%20management%20flexible%20scheduling%20professional%20planning%20therapy%20sessions%20booking%20system%20clean%20organized%20workspace%20accessible%20timing%20simple%20composition&width=800&height=600&seq=service006&orientation=landscape',
      tag: 'Conveniência',
      title: 'Modalidades Flexíveis',
      description: 'Escolha entre atendimento presencial em consultório acolhedor ou online com toda segurança e privacidade.'
    }
  ];

  return (
    <section id="servicos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="text-center mb-16">
          <span className="inline-block bg-[#E0F2EF] text-[#7DD3C0] text-sm font-medium px-4 py-2 rounded-full mb-4">
            Serviços
          </span>
          <h2 className="text-5xl lg:text-6xl font-bold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            <span className="text-[#B0B0B0]">Como Posso</span>
            <br />
            <span className="text-[#2C2C2C]">Ajudar Você</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group cursor-pointer"
            >
              <div className="w-full h-64 rounded-3xl overflow-hidden mb-4 shadow-md group-hover:shadow-xl transition-all duration-300">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <span className="inline-block bg-[#E0F2EF] text-[#7DD3C0] text-sm font-medium px-4 py-1 rounded-full mb-3">
                {service.tag}
              </span>
              <h3 className="text-2xl font-bold text-[#2C2C2C] mb-3">{service.title}</h3>
              <p className="text-[#6B6B6B] leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}